import {
    getStateFromElement,
    setState,
    removeState,
} from '@js/utilities/bootstrap-modules-controller/bootstrapModulesHelpers';

export const tabListener = (tabElements) => {
    tabElements.forEach((el) => {
        const elementData = getStateFromElement(el);

        el.addEventListener(`shown.bs.${elementData.toggle}`, () => {
            setState(elementData.target, {
                ...elementData,
                active: true,
            });
        });

        el.addEventListener(`hidden.bs.${elementData.toggle}`, () => {
            removeState(elementData.target);
        });
    });
};

const activateTabModule = (DOM, element, data) => {
    const togglersToActivate = DOM.querySelectorAll(`[data-bs-target="${data.target}"]`);

    togglersToActivate.forEach((togglerToActivate) => {
        const parent = togglerToActivate.closest('.nav-tabs');

        if (parent) {
            parent.querySelectorAll('.nav-link').forEach((el) => {
                el.classList.remove('active');
            });
        }

        togglerToActivate.classList.add('active');
    });

    const tabsToActivate = DOM.querySelectorAll(data.target);

    tabsToActivate.forEach((tabToActivate) => {
        const parent = tabToActivate.closest('.tab-content');

        if (parent) {
            parent.querySelectorAll('.tab-pane').forEach((el) => {
                el.classList.remove('active', 'show');
            });
        }

        tabToActivate.classList.add('active', 'show');
    });
};

export const tabActivator = (DOM, state) => {
    Object.keys(state).forEach((target) => {
        const targetElement = DOM.querySelector(target);

        activateTabModule(DOM, targetElement, state[target]);
    });

    return DOM;
};
